import React, { useState } from 'react'
import SlidingPane from 'react-sliding-pane'
import closeicon from '../images/close-icon.svg'
import EgeSetup from './EgeSetup/EgeSetup'

const CreateYoursNow = () => {
    const [isPaneOpen, setIsPaneOpen] = useState(false)
    return (
        <>
            <button type="button" className="create-yours-now" onClick={() => setIsPaneOpen(true)}> Create Yours Now </button>
            <SlidingPane className="connector-popup ege-learnmore" overlayClassName="some-custom-overlay-class" isOpen={isPaneOpen}>
                <button type="button" className="popup-close" aria-label="Close" onClick={() => setIsPaneOpen(false)}>
                    <img src={closeicon} alt="" />
                </button>
                <EgeSetup />
            </SlidingPane>
        </>
    )
}

export default CreateYoursNow
